import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import "./login_form.scss";


const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);


  // 🚀 Redirect if already logged in
  useEffect(() => {
    const token = Cookies.get("auth");
    if (token) {
      navigate("/admin/add-review"); // redirect to home (change if needed)
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Hardcoded credentials
    const hardcodedEmail = "bfgjewelappraiser@gmail.com";
    const hardcodedPassword = "admin@123";

    setTimeout(() => {
      if (email === hardcodedEmail && password === hardcodedPassword) {
        Cookies.set("auth", "true");
        alert("Login successful!");
        navigate("/admin/add-review");
      } else {
        alert("Invalid email or password.");
      }
      setLoading(false);
    }, 1000); // simulate delay
  };

  const handleReset = () => {
    setEmail("");
    setPassword("");
  };

  return (
    <div className="login-page-container">
      <form className="login" onSubmit={handleLogin}>
        <h2 className="text-center mb-4">Login</h2>

        <div className="mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Password</label>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="btn btn-primary w-100" disabled={loading}>
  {loading ? "Logging in..." : "Login"}
</button>

<button
  type="button"
  className="btn btn-secondary w-100 mt-2"
  onClick={handleReset}
  disabled={loading}
>
  Reset
</button>

      </form>
    </div>
  );
};

export default LoginForm;
